import React, { useEffect, useState } from "react";
import Logo from "../assets/FullLogo.png";
import { decrypt, encrypt } from "../utils/cryptoUtils"; // Import encryption utilities
import { makeAuthenticatedRequest  } from "../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { loginOtp } from "../redux/LoginSlice";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Otp = () => {
  const [otpEmail, setOtpEmail] = useState(["", "", "", "", "", ""]);
  const [otpMobile, setOtpMobile] = useState(["", "", "", "", "", ""]);
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const login_Otp = useSelector((state) => state.login?.loginData);
  const registerOtp = useSelector((state) => state.login?.RegisterOtp);
  const email = registerOtp?.userdatils?.email || login_Otp?.userdatils?.email || "";
  const mid = String(registerOtp?.userdatils?.user_id || login_Otp?.userdatils?.user_id || "");  
  
  const loginotp = useSelector((state) => state.login?.otp);
  const otp_id = String(loginotp?.Otp_id || "");

  console.log(email +"-----"+mid);

  useEffect(() => {
    const postData = async () => {
        try {
          const requestData = JSON.stringify({
            email: email,
            mid: mid,
            type: "Registration", // Updated field names
          });
  
          const encrypted = encrypt(requestData);
  
          const data = await makeAuthenticatedRequest("POST", "/otp/generate", { encrypted } , navigate);
          const decryptdata = decrypt(data);
          const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));
  
          dispatch(loginOtp(jsonArray)); // Pass the entire response
  
        //   setResponseData(jsonArray);
        } catch (err) {
        //   AxiosError(navigate, error)
        }
    }
    postData();
  }, [dispatch]);

  const handleOtpChange = (index, type, event) => {
    const value = event.target.value;
    if (!/^\d?$/.test(value)) return; // Allow only digits

    const updatedOtp = type === "email" ? [...otpEmail] : [...otpMobile];
    updatedOtp[index] = value;
    type === "email" ? setOtpEmail(updatedOtp) : setOtpMobile(updatedOtp);

    if (value && index < 5) {
      event.target.nextElementSibling?.focus();
    }
  };

  const handleOtpKeyDown = (index, type, event) => {
    const key = event.key;
    const updatedOtp = type === "email" ? [...otpEmail] : [...otpMobile];

    if (key === "Backspace") {
      if (updatedOtp[index] === "") {
        if (index > 0) {
          event.target.previousElementSibling?.focus();
          updatedOtp[index - 1] = "";
        }
      } else {
        updatedOtp[index] = "";
      }
      type === "email" ? setOtpEmail(updatedOtp) : setOtpMobile(updatedOtp);
    }
  };

  const OtpResend = async (e) => {
    try {
        const requestData = JSON.stringify({
          email: email,
          mid: mid,
          type: "Resend", // Updated field names
        });

        const encrypted = encrypt(requestData);

        const data = await makeAuthenticatedRequest("POST", "/otp/generate", { encrypted } , navigate);
        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');

        // Convert to array
        const jsonObject = JSON.parse(fixedString);

        dispatch(loginOtp(jsonObject)); // Pass the entire response

      //   setResponseData(jsonArray);
    } catch (err) {
      //   AxiosError(navigate, error)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailOtp = otpEmail.join("");

    if (otpEmail.includes("")) {
      setEmailError("Enter the full OTP sent to your email.");
      return;
    }

    setEmailError("");

    try {
        const emailOtp = otpEmail.join("");
        const requestData = JSON.stringify({
            email: email,
            otp: emailOtp,
            otp_id: otp_id, // Updated field names
        });

        const encrypted = encrypt(requestData);
  
        const data = await makeAuthenticatedRequest("POST", "/otp/validate", { encrypted } , navigate);
        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"').replace(/^"|"$/g, ''); // clean outer quotes if needed

        // Parse to JSON (Object)
        const jsonObject = JSON.parse(fixedString);


      if (jsonObject.Status === '200') {
        toast.success(jsonObject.Msg);
        console.log("Success:", data);
        navigate("/dashboard");
        // Redirect or further logic here
      } else if(jsonObject.Status === '401') {
        toast.error(jsonObject.Err);
      }
    } catch (error) {
        toast.error("Error:", error);
        console.error("Error:", error);
    //   AxiosError(navigate, error)
    }
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      {/* Left Section */}
      <div className="w-full h-screen lg:w-1/2 flex flex-col justify-center items-center bg-white p-6">
        <div className="mb-8">
          <img src={Logo} alt="Company Logo" className="h-64 md:h-64" />
        </div>

        <div className="w-full max-w-md">
          {/* <p className="text-black mb-6 text-xl md:text-2xl text-center">Enter your OTP</p> */}
          <form id="otpVerification" onSubmit={handleSubmit} className="space-y-6">
            {/* Email OTP */}
            <div>
              <label htmlFor="otpEmail" className="flex justify-center text-gray-500 mb-6 mt-3">
                Enter the code sent to your Email
              </label>
              <div className="flex justify-center gap-2 md:gap-3 mt-5">
                {otpEmail.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, "email", e)}
                    onKeyDown={(e) => handleOtpKeyDown(index, "email", e)}
                    // className="otp-input email-otp w-10 h-10 md:w-14 md:h-14 text-center text-lg border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    className={`otp-input email-otp w-10 h-10 md:w-12 md:h-12 text-center text-lg rounded-md border focus:outline-none focus:ring-2 ${
                      emailError ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-[#299F1F]'
                    }`}
                    
                  />
                ))}
              </div>
              {emailError && <p className="text-red-500 text-sm mt-4 text-center">{emailError}</p>}
            </div>

            {/* Mobile OTP (optional - you can remove this section if not needed) */}
            {/* 
            <div>
              <label htmlFor="otpMobile" className="block text-sm font-medium text-gray-700 mt-6">
                Enter the code sent to your mobile
              </label>
              <div className="flex justify-center gap-2 md:gap-3 mt-5">
                {otpMobile.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, "mobile", e)}
                    onKeyDown={(e) => handleOtpKeyDown(index, "mobile", e)}
                    className="otp-input mobile-otp w-10 h-10 md:w-14 md:h-14 text-center text-lg border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                ))}
              </div>
              {mobileError && <p className="text-red-500 text-sm mt-4 text-center">{mobileError}</p>}
            </div>
            */}

            <button type="submit" className="w-full block text-center bg-[#299F1F] text-white py-2 px-6 rounded-md hover:bg-green-700 transition">
              Verify
            </button>
          </form>
          <div className="text-center">
              <button onClick={OtpResend} className="text-[#299F1F] text-sm">Resend OTP</button>
            </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="hidden md:flex w-1/2 bg-[#299F1F] justify-center items-center text-white relative px-6 text-center">
        <div>
          <div className="flex items-center gap-2 justify-center">
            <h1 className="text-3xl font-bold">Janta Pay</h1>
          </div>
          <p className="mt-4 text-gray-300">Sign up to unlock secure and smooth payment solutions</p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
    
  );
};

export default Otp;
